import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import stringSimilarity from "string-similarity";

/**
 * The site is English-only: the EN/GA switcher is commented out in both
 * navbars and public/locales/en/translation.json is empty (English lives in
 * the JSX).
 *
 * LanguageDetector was deliberately removed. Its default detection order
 * starts with `querystring`, which made `?lng=ga` a crawlable duplicate of
 * every page on the site, and `navigator`, which served partial Irish content
 * at English URLs to anyone whose browser locale was Irish. Both are real
 * duplicate-content and cloaking risks for SEO.
 *
 * `lng` is pinned instead. If Irish is ever launched properly, re-add the
 * detector WITH an explicit `detection.order` that excludes `querystring`,
 * and give Irish its own URL prefix (/ga/...) plus hreflang tags - never a
 * query parameter.
 */
async function initializeI18n() {

    i18n
        .use(Backend)
        .use(initReactI18next)
        .init({
            debug: false,
            lng: "en",
            fallbackLng: "en",
            supportedLngs: ["en"],
            returnObjects: true,
            backend: {
                loadPath: '/locales/{{lng}}/translation.json',
            },
            saveMissing: true,
            missingKeyHandler: (lngs, ns, key, fallbackValue) => {
                // const currentLanguage = i18n.language;

                // if (currentLanguage === 'en') {
                //     // console.warn(`Missing translation key '${key}' in language '${currentLanguage}'`);
                //     return fallbackValue; // Skip custom logic for 'en' language
                // }



                // const similarKey = findSimilarKey(key);
                // let result = fallbackValue;

                // if (similarKey) {
                //     console.warn(`DEBUG i: Loosely matched translation key '${key}' with '${similarKey}'`);
                //     result = translationMap.get(similarKey);
                // } else {
                //     console.log(`DEBUG irr: mtk: '${key}'`);
                // }
                // if (similarKey === key) {
                //     console.log(`DEBUG i: mtksim: '${key}'`);
                // }
                // console.warn(`DEBUG ir: Returning translation: ${result}`);
                // return result;
            },
        });
}


export default initializeI18n;
